<template>
  <div>
    <checkbox-input v-if="explicitConsentRequired" :initial-value="value" :checkbox-id="calculatedInputId"
                    :input-name="inputName" :label="label" :show-label="showLabel" :validation-errors="validationErrors"
                    @change="changed" @focus="$emit('focus')" />
    <div v-else class="small-text">
      <span v-if="showLabel" class="mb-3" v-html="label" />
      <input type="hidden" :name="inputName" value="true">
    </div>
  </div>
</template>

<script>
import CheckboxInput from './checkbox-input'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { CheckboxInput },

  mixins: [ WithInputIdAndName ],

  props: {
    entityName: {
      type: String,
      required: true
    },

    explicitConsentRequired: {
      type: Boolean,
      required: true
    },

    label: {
      type: String,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    },

    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    return {
      fieldName: 'eu-data-processing-consent'
    }
  },

  mounted() {
    // If consent is required implicitly we need to emit the changed event when the component
    // is just loaded so the parent is notified and the value is set on the model
    if (!this.explicitConsentRequired) {
      this.changed(true)
    }
  },

  methods: {
    changed(value) {
      this.$emit('changed', value)
    }
  }
}
</script>
